/**
 * 审核状态
 */
export enum AUDIT_STATUS {
  /**
   * 未提交
   */
  INIT = -1,
  /**
   * 等待审核
   */
  AUDIT = 0,
  /**
   * 审核通过
   */
  PASS = 1,
  /**
   * 审核不通过
   */
  REJECT = 2,
}